import { GraphQLFormattedError } from 'graphql';

export const GRAPHQL_TOO_MANY_REQUESTS_CODE = 'TOO_MANY_REQUESTS';

export const GRAPHQL_RATE_LIMIT_EVENT = 'graphql-rate-limit';

export interface GraphqlRateLimitEventDetail {
  retryAfter?: number;
}

let graphqlRateLimitKeyCounter = 0;

type ApolloErrorLike = GraphQLFormattedError & {
  graphQLErrors?: GraphQLFormattedError[];
  networkError?: {
    result?: {
      errors?: GraphQLFormattedError[];
    };
  };
};

const hasRateLimitCode = (error?: GraphQLFormattedError | null): boolean =>
  error?.extensions?.code === GRAPHQL_TOO_MANY_REQUESTS_CODE;

export const createGraphqlRateLimitKey = (): string => {
  graphqlRateLimitKeyCounter += 1;

  return `${Date.now()}-${graphqlRateLimitKeyCounter}`;
};

export const isRateLimitGqlError = ({
  extensions
}: GraphQLFormattedError): boolean =>
  extensions?.code === GRAPHQL_TOO_MANY_REQUESTS_CODE;

const getRetryAfter = ({
  extensions
}: GraphQLFormattedError): number | undefined => {
  const retryAfter = extensions?.retryAfter;

  return typeof retryAfter === 'number' ? retryAfter : undefined;
};

const getRateLimitDetail = (
  error: GraphQLFormattedError
): GraphqlRateLimitEventDetail => ({
  retryAfter: getRetryAfter(error)
});

export const dispatchGraphqlRateLimitEvent = (error: GraphQLFormattedError) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<GraphqlRateLimitEventDetail>(GRAPHQL_RATE_LIMIT_EVENT, {
      detail: getRateLimitDetail(error)
    })
  );
};

export const isGraphqlRateLimitError = (error: unknown): boolean => {
  const apolloError = error as ApolloErrorLike | null | undefined;

  return (
    hasRateLimitCode(apolloError) ||
    apolloError?.graphQLErrors?.some(hasRateLimitCode) ||
    apolloError?.networkError?.result?.errors?.some(hasRateLimitCode) ||
    false
  );
};
